var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconThumbsUp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 11.9168H3.13333V4.76679H0.75V11.9168ZM13.8583 5.36262C13.8583 4.70721 13.3221 4.17096 12.6667 4.17096H8.90696L9.473 1.448L9.49088 1.25733C9.49088 1.01304 9.38958 0.786622 9.22871 0.625747L8.59713 0.00012207L4.67654 3.92666C4.45608 4.14116 4.325 4.43908 4.325 4.76679V10.7251C4.325 11.3805 4.86125 11.9168 5.51667 11.9168H10.8792C11.3737 11.9168 11.7968 11.6189 11.9755 11.1899L13.7749 6.98925C13.8285 6.8522 13.8583 6.70921 13.8583 6.55429V5.36262Z",
    fill: "white",
    fillOpacity: 0.54
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconThumbsUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_thumbs_up.b5c7dcf274f6bd24d5c430ebbac0a497.svg";